import { useCapability } from 'navigation-components/platform/hooks';
import { capabilities } from 'navigation-components/capabilities';
import { useCallback, useEffect } from 'react';
// @ts-expect-error file not typed
import { setupCsat } from 'wootric-nps/csat/csat-setup';
export const useSubscribeToWootricSurveys = () => {
  const {
    subscribe: subscribeToSurveyUpdates
  } = useCapability(capabilities.TOGGLE_WOOTRIC_SURVEY_CAP.getName());
  const handleSurveyUpdate = useCallback(({
    surveyName
  }) => {
    setupCsat(surveyName);
  }, []);
  useEffect(() => {
    return subscribeToSurveyUpdates(handleSurveyUpdate);
  }, [handleSurveyUpdate, subscribeToSurveyUpdates]);
};